import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from "@roc/ui";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { PointOfContactTableRow } from "./PointOfContactTableRow";
import { PointOfContactStore } from '../../../stores/documentForms/pointOfContact/pointOfContactStore';
import NewPointOfContactForm from "./PointOfContactForm";


const useStyles = makeStyles((theme: Theme) => ({
  noBorderCell: {
    border: 0,
  },
  borderCell: {
    border: '1px solid rgba(224, 224, 224, 1)'
  },
  addButton: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  cancelButton: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  table: {
    '& th': {
      borderBottom: '1px solid #eee'
    }
  },
  headerRow: {
    border: '1px solid #ccc',
    backgroundColor: '#f8f8f8',
    '& th': {
      padding: '8px'
    }
  }
}));

export type TierPricingEconomicsTableProps = {
  emptyMessage: string;
  store: PointOfContactStore;
  allowActions?: boolean;
  readOnly?: boolean
  isInternalValuationPropertyPhotosContactFlow?: boolean,
  type?: string
};


export const PointsOfContactsTable = observer((
  { emptyMessage, store, type }: TierPricingEconomicsTableProps) => {
  const { pointOfContactsList } = store;
  const classes = useStyles({});

  const setShowPointOfContactForm = (value: boolean) => {
    store?.setIsNewPointOfContactOpen(value)
  }
  const loanId = store.loanStore.loanDetails?.loanId;


  useEffect(() => {
    console.log({ store })
    store.getPointOfContactsList(loanId, type);
  }, [loanId]);

  return (
    <Grid container>
      {!store?.isNewPointFormOfContactOpen && <Grid container xs={12} justifyContent='flex-end'>
        <Button
          color="primary"
          variant="contained"
          className={classes.addButton}
          onClick={() => setShowPointOfContactForm(true)}
          testId="save">
          + Point of Contact
        </Button>
      </Grid>}
      {
        store?.isNewPointFormOfContactOpen && <Grid container xs={12} justifyContent='flex-end' spacing={2}>
          <NewPointOfContactForm store={store} />
          <Button
            color="secondary"
            variant="outlined"
            className={classes.cancelButton}
            onClick={() => setShowPointOfContactForm(false)}
            testId="cancel">
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.addButton}
            onClick={() => store.savePointOfContact(store.loanStore?.loanDetails?.loanId,
              {
                ...store?.pointOfContactFormStore.getFormValues(),
                taskIds: null,
                type: type,
              }, type)}
            testId="save">
            Save
          </Button>
        </Grid>
      }
      {!store?.isNewPointFormOfContactOpen && <Table>
        <TableHead>
          <TableRow className={classes.headerRow}>
            <TableCell>Contact Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Cellphone</TableCell>
            <TableCell>Created Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pointOfContactsList?.length == 0 ?
            <TableRow>
              <TableCell colSpan={5} className={classes.borderCell}>
                <Box textAlign={'center'}>
                  {emptyMessage}
                </Box>
              </TableCell>
            </TableRow>
            :
            pointOfContactsList?.map((contact) => (
              <PointOfContactTableRow
                store={store}
                contact={contact} />
            ))
          }
        </TableBody>
      </Table>}
    </Grid>
  )
});
